export const jaJp = {
    '微信验证码': 'wechat認証コード',
    '账号密码': 'アカウントのパスワード',

    '用户名': 'ユーザー名',
    '密码': 'パスワード',
    '登 录': '登录',
    '邮箱验证码': 'メールボックス認証コード',
    '发送': '送信',
    '绑 定': 'を束ねて定',
    '微信二维码': 'wechat qrコード',
    '用户名不能为空': 'ユーザー名は空にしない',
    '密码不能为空': 'パスワードは空欄にしない',
    '邮箱不能为空': 'メールボックスは空にしてはいけない',
    '验证码不能为空': 'captchaを空にすることはできない',
    '发送成功': '送信成功'
}
